function processStaticHyperlinks(text) {
    if (!text || typeof text !== 'string') return text;
    
    // Process all [text](url) patterns, but skip numeric citations
    var textHyperlinkRegex = /\[([^\]]+)\]\(([^)]+)\)/g;
    return text.replace(textHyperlinkRegex, function(match, linkText, linkUrl) {
        // Skip if this is a numeric citation - let citation logic handle it
        if (/^\d+$/.test(linkText.trim())) {
            return match; // Return unchanged for numeric patterns
        }
        // Convert non-numeric text to clean hyperlink
        return '<a style="text-decoration:none; cursor:pointer;" href="' + linkUrl + '" onclick="event.preventDefault(); window.open(\'' + linkUrl + '\', \'_blank\');">' + linkText + '</a>';
    });
}

function processKeyPointLine(line) {

    var processed = line;

    processed = processed.replace(/\[\[(\d+)\]\]\(([^)]+)\)/g, function(match, num, url) {
        return '<span class="citation-circle" onclick="wmdPageLink(\'ai-search_ref-ar-click-' + num + '\', this); window.open(\'' + url + '\', \'_blank\');" style="cursor: pointer;">' + num + '</span>';
    });

    processed = processed.replace(/\[(\d+)\]\(([^)]+)\)/g, function(match, num, url) {
        return '<span class="citation-circle" onclick="wmdPageLink(\'ai-search_ref-ar-click-' + num + '\', this); window.open(\'' + url + '\', \'_blank\');" style="cursor: pointer;">' + num + '</span>';
    });

    processed = processed.replace(/\[\[(\d+)\]\]/g, function(match, num) {
        return '<span class="citation-circle" onclick="wmdPageLink(\'ai-search_ref-ar-click-' + num + '\', this);" style="cursor: pointer;">' + num + '</span>';
    });

    processed = processed.replace(/\[(\d+)\]/g, function(match, num) {
        return '<span class="citation-circle" onclick="wmdPageLink(\'ai-search_ref-ar-click-' + num + '\', this);" style="cursor: pointer;">' + num + '</span>';
    });

    return processed;
}

function parseBullets(keyPointsText) {
    return keyPointsText
        .split('\n')
        .map(function(line) { return line.trim(); })
        .filter(function(line) { return line.length > 0 && line.startsWith('-'); })
        .map(function(line) { 
            var textWithoutBullet = line.substring(1).trim();
            var withHyperlinks = processStaticHyperlinks(textWithoutBullet);
            return processKeyPointLine(withHyperlinks);
        });
}

function formatKeyPointText(text) {
    if (!text) return text;

    // Bold: **text** → <b>text</b>
    text = text.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');

    // Italic: *text* → <i>text</i>  (skip if adjacent to another *)
    text = text.replace(/(?:^|[^*])\*([^*]+?)\*(?=[^*]|$)/g, function(match, content, offset, string) {
        var beforeChar = offset > 0 ? string[offset - 1] : '';
        var afterChar = offset + match.length < string.length ? string[offset + match.length] : '';
        if (beforeChar !== '*' && afterChar !== '*') {
            return match.replace(/\*([^*]+?)\*/, '<i>$1</i>');
        }
        return match;
    });

    return text;
}

function deduplicateQuestions(questions, max) {
    var limit = (typeof max === 'number' && max > 0) ? max : 5;
    var seen   = {};
    var unique = [];
    (questions || []).forEach(function(q) {
        var normalized = q.trim().toLowerCase();
        if (!seen[normalized] && unique.length < limit) {
            seen[normalized] = true;
            unique.push(q.trim());
        }
    });
    return unique;
}

module.exports = {
    processStaticHyperlinks: processStaticHyperlinks,
    processKeyPointLine:   processKeyPointLine,
    parseBullets:          parseBullets,
    formatKeyPointText:    formatKeyPointText,
    deduplicateQuestions:  deduplicateQuestions
};
